export const companyOnboardingRoutePath = '/company-onboarding';
